import { MRT_ColumnDef } from "material-react-table";
import type { Job, Branch } from "../../../../api/types";
import { ColumnContext, selectColumn } from "./standard-column-types";
import { isFieldRequired } from "../../../../utilities/jobValidation";
import { getJobPriorities, JobsPriority } from "../../../../utilities/types";

export function column_Density(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "importDensity", "density", {
		isNumber: true,
		options: context.gridSizes,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}

export function column_Depth(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "importDepth", "depth", {
		isNumber: true,
		options: context.depths,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}

export function column_TestPackage(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "externalTestPackageId", "testPackage", {
		options: context.labPackages,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}

export function column_FrequencyOfMicros(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "externalFrequencyOfMicros", "frequencyOfMicros", {
		isNumber: true,
		options: context.micros,
		size: 100,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}

export function column_FieldPriority(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn<string>(context, "fieldPriority", "fieldPriority", {
		freeSolo: false,
		options: [...getJobPriorities()],
		size: 250,
		hasGroupUpdate: false,
		getValue: (job) => job.fieldPriority || "Regular Turn (default)",
		setValue: (job, value) => {
			job.fieldPriority = (value || "Regular Turn (default)") as JobsPriority;
		},
	});
}

export function column_Branch(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn<Branch>(context, "branchIds", "branch", {
		options: context.props.branches || [],
		freeSolo: false,
		isRequired: () => isFieldRequired("branch", context.validationContext),
		size: 300,
		getOptionLabel: (branch) => branch.name,
		isOptionEqualToValue: (option, value) => option.id === value.id,
		getValue: (job) => (context.props.branches || []).find((branch) => job.branchIds?.includes(branch.id)) || null,
		setValue: (job, branch) => {
			job.branchIds = branch ? [branch.id] : [];
		},
	});
}
